import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeeExecutionsPage } from 'src/modules/automations/components/pages/employees/executions/executions.page';
import {
  executionsPathSchema,
  executionsSearchSchema,
} from 'src/modules/automations/schemas/employees/executions.schema';

export const Route = createFileRoute('/employees/$employeeId/executions/')({
  component: ExecutionsListComponent,
  validateSearch: (search) => executionsSearchSchema.parse(search),
  params: {
    parse: (params) => executionsPathSchema.parse(params),
  },
});

function ExecutionsListComponent() {
  const { employeeId } = Route.useParams();

  return (
    <AuthenticateRoute>
      <EmployeeExecutionsPage employeeId={employeeId} />
    </AuthenticateRoute>
  );
}
